import React from 'react';
import { connect } from 'react-redux';
import { withRouter, browserHistory , Link } from 'react-router';
import * as FacilitiesActions from '../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import Header from '../../components/header';
import { validate } from '../../validations';
import ReactTooltip from 'react-tooltip';
import { ModalDialogCommon } from '../modal_dialog_common';
let screenIdentifier = 'facilities_edit';
import InputMask from 'react-input-mask';
import _ from 'lodash';

export var Editfacility = React.createClass({
    getInitialState() {
        return {
            isFormSubmited: null,
            isImageUploaded: false,
            fileUploaded: null,
            isSubmitEnabled: null,
            isEditMode: null,
            zipCssClass: "inputText",
            mobileCssClass: "inputText",
            deskNumberCssClass: "inputText",
            updateFacilityResponseSuccess: null,
        }
    },
    componentWillReceiveProps(nextProps) {

        if (this.state.isSubmitEnabled && this.state.isFormSubmited) {
            this.setState({ isSubmitEnabled: null, isFormSubmited: null });

            if (nextProps.FacilitiesDetails.FaciliteUpdateDeatils.status != 200) {
                this.setState({ Okmessage: nextProps.FacilitiesDetails.FaciliteUpdateDeatils.message, updateFacilityResponseSuccess: null });
            } else {
                this.setState({ Okmessage: nextProps.FacilitiesDetails.FaciliteUpdateDeatils.message });
                this.setState({ isEditMode: null, updateFacilityResponseSuccess: true });
                this.props.Dispatch(FacilitiesActions.getAllfacilitiesById(this.props.FacilitiesDetails.FaciliteDetailsByID.data.id));
            }

        }

        // Facility image upload response
        if (nextProps.FacilitiesDetails.FacilityImageUpload && nextProps.FacilitiesDetails.FacilityImageUpload.status == 200) {
            nextProps.FacilitiesDetails.FacilityImageUpload.status = null;
            this.setState({ isImageUploaded: true, isEditMode: true, isSubmitEnabled: true });
        }
        else {
            this.setState({ isImageUploaded: false, isEditMode: null, isSubmitEnabled: null });
        }

    },
    facilityDetail() {
        return this.props.FacilitiesDetails.FaciliteDetailsByID ? this.props.FacilitiesDetails.FaciliteDetailsByID.data : false;
    },

    email_validate(event) {
        validate.email(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    phone_validate(event) {
        validate.phone(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    alternate_phone_validate(event) {
        if (event.target.value.trim().length) {
            validate.phone(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
        }
    },

    zipcode_validate(event) {
        validate.zipCode(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    url_validate(event) {
        let url = event.target.value.trim();
        if (url.length > 0) {
            validate.website(url) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
        }
    },

    no_empty(event) {
        event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    isValidMaxAdmin(event) {
        let isValidMaxAdmin = validate.onlyNum(event.target.value.trim()) && (event.target.value.trim() <= 99 && event.target.value.trim() > 0);
        isValidMaxAdmin ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    isValidMaxStaff(event) {
        let isValidMaxStaff = validate.onlyNum(event.target.value.trim()) && (event.target.value.trim() <= 999 && event.target.value.trim() > 0);
        isValidMaxStaff ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    isValidMaxPatient(event) {
        let isValidMaxPatient = validate.onlyNum(event.target.value.trim()) && (event.target.value.trim() <= 99999 && event.target.value.trim() > 0);
        isValidMaxPatient ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    },

    remove_error(event) {
        event.target.className = 'inputText';
    },

    enableSubmit() {
        this.setState({ isSubmitEnabled: true });
        this.setState({ isEditMode: true });
    },

    updateFacilityDetail(e) {

        this.setState({ Okmessage: null, isFormSubmited: null });

        // To make the fields editable
        if (!this.state.isEditMode) {
            this.setState({ isEditMode: true });
            return;
        }
        if (this.state.isEditMode && !this.state.isSubmitEnabled) {
            this.setState({ Okmessage: "Please update any field to save." });
            return;
        }

        let maxNoOfStaff = this.refs['maxNoOfStaff'],
            maxNoOfPatient = this.refs['maxNoOfPatient'],
            maxNoOfAdmin = this.refs['maxNoOfAdmin'];

        //validation for name
        let isValidName = validate.name(this.refs['name']);
        isValidName ? this.refs.name.className = 'inputText' : this.refs.name.className = 'inputText error';

        //validation for Email
        let isValidEmail = validate.email(this.refs['email'].value.trim());
        isValidEmail ? this.refs.email.className = 'inputText' : this.refs.email.className = 'inputText error';

        //validation for mobile
        let isValidmobile = validate.phone(this.refs.mobile.state.value);
        !isValidmobile ? this.setState({ mobileCssClass: "inputText error" }) : this.setState({ mobileCssClass: "inputText" });

        //validation for desk number
        let isAltenatePhoneAvailable = null;
        let isValidDeskNumber = null;
        if (this.refs.deskNumber.state.value.trim().length) {
            isAltenatePhoneAvailable = true;
            isValidDeskNumber = validate.phone(this.refs.deskNumber.state.value);
            !isValidDeskNumber ? this.setState({ deskNumberCssClass: "inputText error" }) : this.setState({ deskNumberCssClass: "inputText" });
        }

        //validation for Url
        let isValidwebsiteUrl = null,
            Url = this.refs.url.value.trim();
        if (Url.length > 0) {
            isValidwebsiteUrl = validate.website(Url);
            !isValidwebsiteUrl ? this.refs.url.className = "inputText error" : this.refs.url.className = "inputText";
        } else {
            this.refs.url.className = "inputText";
        }

        // validation for Street
        let isValidstreet = validate.name(this.refs['street']);
        isValidstreet ? this.refs.street.className = 'inputText' : this.refs.street.className = 'inputText error';

        //validation for city
        let isValidCity = validate.name(this.refs['city']);
        isValidCity ? this.refs.city.className = 'inputText' : this.refs.city.className = 'inputText error';

        // validation for State
        let isValidState = validate.name(this.refs['state']);
        isValidState ? this.refs.state.className = 'inputText' : this.refs.state.className = 'inputText error';

        // validation for Country
        let isValidCountry = validate.name(this.refs['country']);
        isValidCountry ? this.refs.country.className = 'inputText' : this.refs.country.className = 'inputText error';

        //validation for zip code
        let isValidZipCode = validate.zipCode(this.refs.zipCode.state.value);
        isValidZipCode && !(this.refs.zipCode.state.value <= 0) ? this.setState({ zipCssClass: "inputText" }) : this.setState({ zipCssClass: "inputText error" });


        //validation for max admin
        let isValidMaxAdmin = validate.onlyNum(maxNoOfAdmin.value) && (maxNoOfAdmin.value <= 99 && maxNoOfAdmin.value > 0);
        isValidMaxAdmin ? maxNoOfAdmin.className = "inputText" : maxNoOfAdmin.className = "inputText error";

        //validation for max staff
        let isValidMaxStaff = validate.onlyNum(maxNoOfStaff.value) && (maxNoOfStaff.value <= 999 && maxNoOfStaff.value > 0);
        isValidMaxStaff ? maxNoOfStaff.className = "inputText" : maxNoOfStaff.className = "inputText error";

        //validation for max Patient
        let isValidMaxPatient = validate.onlyNum(maxNoOfPatient.value) && (maxNoOfPatient.value <= 99999 && maxNoOfPatient.value > 0);
        isValidMaxPatient ? maxNoOfPatient.className = "inputText" : maxNoOfPatient.className = "inputText error";

        let existingfacilityAdminLength =  parseInt(maxNoOfAdmin.value) >=  parseInt(this.props.location.query.al);
        existingfacilityAdminLength ? "inputText" : maxNoOfAdmin.className = "inputText error";

        let activeStaffLength =  parseInt(maxNoOfStaff.value) >=  parseInt(this.props.location.query.sl);
        activeStaffLength ? "inputText" : maxNoOfStaff.className = "inputText error";

        let activePatientLength =  parseInt(maxNoOfPatient.value) >= parseInt(this.props.location.query.pl);
        activePatientLength ? "inputText" : maxNoOfPatient.className = "inputText error";

        if (this.refs.name.value.trim().length === 0 || this.refs.email.value.trim().length === 0 || this.refs.street.value.trim().length === 0 || this.refs.city.value.trim().length === 0 || this.refs.state.value.trim().length === 0 || this.refs.country.value.trim().length === 0 || this.refs.zipCode.state.value.trim().length === 0 || this.refs.mobile.state.value.length === 0 || this.refs.maxNoOfStaff.value.trim().length === 0 || this.refs.maxNoOfPatient.value.trim().length === 0 || this.refs.maxNoOfAdmin.value.trim().length === 0) {
            this.setState({ Okmessage: 'Please enter necessary fields to proceed.' });
            return false;
        }

        if (isValidName && isValidEmail && isValidmobile && (isAltenatePhoneAvailable ? isValidDeskNumber : true) && (Url.length > 0 ? isValidwebsiteUrl : true) && isValidstreet && isValidCity && isValidState && isValidCountry && isValidZipCode && validate.onlyNum(maxNoOfAdmin.value) && validate.onlyNum(maxNoOfStaff.value) && validate.onlyNum(maxNoOfPatient.value)) {
            if (!isValidMaxAdmin) {
                this.setState({ Okmessage: "Admin count should be greater than 0 and less than 99." })
                return false;
            }
            else if (!isValidMaxStaff) {
                this.setState({ Okmessage: "Staff count should be greater than 0 and less than 999." })
                return false;
            }
            else if (!isValidMaxPatient) {
                this.setState({ Okmessage: "Patient count should be greater than 0 and less than 99999." })
                return false;
            }
            else if (!existingfacilityAdminLength) {
                this.setState({ Okmessage: 'Max admin count cannot be less then active admin count.' });
                return false;
            }
            else if (!activeStaffLength) {
                this.setState({ Okmessage: 'Max staff count cannot be less then active staff count.' });
                return false;
            }
            else if (!activePatientLength) {
                this.setState({ Okmessage: 'Max Patient count cannot be less then active Patient count.' });
                return false;
            }
        }
        else {
            this.setState({ Okmessage: 'Please enter valid information to proceed.' });
            return;
        }

        if (isValidName && isValidEmail && isValidmobile && (isAltenatePhoneAvailable ? isValidDeskNumber : true) && (Url.length > 0 ? isValidwebsiteUrl : true) && isValidstreet && isValidCity && isValidState && isValidCountry && isValidZipCode && isValidMaxAdmin && isValidMaxStaff && isValidMaxPatient) {
            var data = {};
            data.name = this.refs['name'].value.trim();
            data.email = this.refs['email'].value.trim();
            data.mobile = this.refs.mobile.state.value.replace(/ /g, "");
            if (isValidDeskNumber) {
                data.deskNumber = this.refs.deskNumber.state.value.replace(/ /g, "");
            }
            data.url = this.refs['url'].value.trim();

            data.address = {
                "street": this.refs['street'].value.trim(),
                "city": this.refs['city'].value.trim(),
                "state": this.refs['state'].value.trim(),
                "country": this.refs['country'].value.trim(),
                "zipCode": this.refs['zipCode'].state.value.trim(),
            }
            if (this.state.isImageUploaded && this.props.FacilitiesDetails.FacilityImageUpload.data) {
                data.imageUrl = this.props.FacilitiesDetails.FacilityImageUpload.data;
            }
            data.id = this.props.FacilitiesDetails.FaciliteDetailsByID.data.id;
            data.updatedBy = { "id": this.props.UserDetails.selectedUserRoleID };

            data.maxNoOfAdmin = this.refs['maxNoOfAdmin'].value.trim();
            data.maxNoOfStaff = this.refs['maxNoOfStaff'].value.trim();
            data.maxNoOfPatient = this.refs['maxNoOfPatient'].value.trim();

            this.setState({ isFormSubmited: true });
            this.props.Dispatch(FacilitiesActions.updateFacility(data));

        } else {
            this.setState({ Okmessage: 'Please enter valid information.' });
        }

    },
    closebox() {
        this.setState({ Okmessage: null });
        if (this.state.updateFacilityResponseSuccess) {
            this.setState({ updateFacilityResponseSuccess: null });
            this.props.router.goBack();
            document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
        }
    },
    cancel() {
        this.props.router.goBack();
        document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
    },


    uploadFacilityImage(e) {
        // if User doesn't select(if he click on cancle) any image
        //To check if user upload any file
        if (e.target.files.length === 0) {
            return;
        }

        var fuData = e.target.files[0];
        var FileUploadPath = fuData.name;
        var size = fuData.size;

        //To check the uploaded file is an image
        var Extension = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
        if (Extension == "png" || Extension == "jpeg" || Extension == "jpg") {

            if (size < 2097152) {
                var files = e.target.files || e.dataTransfer.files;
                var imageData = new FormData();
                let file = files[0];
                this.setState({ fileUploaded: file.name });
                imageData.append("file", e.target.files[0]);
                this.props.Dispatch(FacilitiesActions.uploadFacilityImage(imageData));
            }
            else {
                e.target.value = "";
                this.setState({ Okmessage: "Please select an image that is less than 2MB.", });
            }

        }
        else {
            e.target.value = "";
            this.setState({
                Okmessage: "Only photos with extension .png, .jpg, .jpeg are allowed.",
            })
        }
    },

    render() {
        var self = this;
        var style = {
            color: 'red'
        };
        var details = this.facilityDetail();
        var userlimitTrue = window.location.search ? validate.getUrlParam('user_limit') : false;
        var id = userlimitTrue ? "edit_only_user_limit" : "";
        return (
            <div className="dashboard-inner-content" >
                <Header screenIdentifier={screenIdentifier} breadcrumb ={true}/>
                <div className="breadcrumb-custom">
                  <h2> <Link  to='/facilities'>CLINICS</Link> >  <a  onClick={this.props.router.goBack}>{details.name}</a> > {id == "edit_only_user_limit"? 'EDIT USER LIMIT':'EDIT'} </h2>
                </div>
                <div className="white-box">
                    <div className="create-facility">

                        <div className="row">

                            <div id={id}>

                                <div className="col-xs-6 no-padding facility-details">
                                    <h4>Clinic details</h4>
                                    <div className="input-group">
                                        <input type="text" className="inputText" maxLength="64" ref="name" tabIndex={userlimitTrue ? -1 : 1} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} defaultValue={details.name} />
                                        <span className="floating-label">Clinic Name</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" maxLength="64" ref="email" tabIndex={userlimitTrue ? -1 : 2} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.email_validate} defaultValue={details.email} />
                                        <span className="floating-label">Email</span>
                                    </div>
                                    <div className="input-group">
                                        <InputMask type="text" className={this.state.mobileCssClass} ref="mobile" tabIndex={userlimitTrue ? -1 : 3} defaultValue={details.mobile} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.phone_validate} mask="999 999 9999" maskChar={null}></InputMask>
                                        <span className="floating-label">Primary Phone</span>
                                    </div>
                                    <div className="input-group">
                                        <InputMask type="text" className={this.state.deskNumberCssClass} tabIndex={userlimitTrue ? -1 : 4} defaultValue={details.deskNumber} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.alternate_phone_validate} ref="deskNumber" mask="999 999 9999" maskChar={null}></InputMask>
                                        <span className="floating-label" >Alternate Phone </span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" maxLength="64" ref="url" tabIndex={userlimitTrue ? -1 : 5} defaultValue={details.url} onBlur={this.url_validate} onChange={this.enableSubmit} onFocus={this.remove_error} />
                                        <span className="floating-label">Website</span>
                                    </div>

                                    <div className="facility-upload">
                                        <p>  <label className="uploadBtn gray-button" htmlFor="upload">Upload Clinic image</label>
                                            <input type="file" id="upload" ref="facilityImageUrl" tabIndex={userlimitTrue ? -1 : 6} onChange={this.uploadFacilityImage} onFocus={this.remove_error} required />
                                            <span>{this.state.fileUploaded && this.state.fileUploaded} </span>
                                        </p>
                                    </div>

                                </div>
                                <div className="col-xs-6 no-padding facility-details address">
                                    <h4>Address</h4>
                                    <div className="input-group">
                                        <input type="text" className="inputText" maxLength="64" ref="street" tabIndex={userlimitTrue ? -1 : 7} defaultValue={details.address.street} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} />
                                        <span className="floating-label">Street</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" maxLength="64" ref="city" tabIndex={userlimitTrue ? -1 : 8} defaultValue={details.address.city} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} />
                                        <span className="floating-label">City</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" maxLength="64" ref="state" tabIndex={userlimitTrue ? -1 : 9} defaultValue={details.address.state} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} />
                                        <span className="floating-label">State</span>
                                    </div>
                                    <div className="input-group">
                                        <input type="text" className="inputText" maxLength="64" ref="country" tabIndex={userlimitTrue ? -1 : 10} defaultValue={details.address.country} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.no_empty} />
                                        <span className="floating-label">Country</span>
                                    </div>
                                    <div className="input-group">
                                        <InputMask type="text" className={this.state.zipCssClass} tabIndex={userlimitTrue ? -1 : 11} defaultValue={details.address.zipCode} onFocus={this.remove_error} onChange={this.enableSubmit} onBlur={this.zipcode_validate} ref="zipCode" maxLength="5" mask="99999" maskChar={null} required />

                                        <span className="floating-label">Zip</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">

                        </div>
                        <h4>Set User Limit <img className="question-markimage" data-tip="<div><p>Maximum number of Admin : 99</p><p>Maximum number of Staff : 999</p>
<p>Maximum number of Patients : 99999</p></div>" data-html={true}src={require('./../../images/question-icon.png')}/></h4>
                <ReactTooltip html={true} />
                <div className="row">
                    <div className="col-xs-11 user-limit no-padding">
                        <div className="col-xs-4 no-padding">
                            <div className="input-group">
                                <input type="text" className="inputText" ref="maxNoOfAdmin" tabIndex="12" defaultValue={details.maxNoOfAdmin} onBlur={this.isValidMaxAdmin} onChange={this.enableSubmit} onFocus={this.remove_error} maxLength="2" />
                                <span className="floating-label">Admin</span>
                            </div>
                        </div>
                        <div className="col-xs-4 no-padding">
                            <div className="input-group">
                                <input type="text" className="inputText" tabIndex="13" defaultValue={details.maxNoOfStaff} ref="maxNoOfStaff" onBlur={this.isValidMaxStaff} onChange={this.enableSubmit} onFocus={this.remove_error} maxLength="3" />
                                <span className="floating-label">Staff</span>
                            </div>
                        </div>
                        <div className="col-xs-4 no-padding">
                            <div className="input-group">
                                <input type="text" className="inputText" tabIndex="14" defaultValue={details.maxNoOfPatient} ref="maxNoOfPatient" onBlur={this.isValidMaxPatient} onChange={this.enableSubmit} onFocus={this.remove_error} maxLength="5" />
                                <span className="floating-label">Patients</span>
                            </div>
                        </div>
                    </div>
                </div>

                <button className="gray-button create-facility-button margin-right-10" onClick={this.updateFacilityDetail}>{this.state.isEditMode ? "SAVE" : "SAVE"}</button>

                <button className="gray-button create-facility-button" onClick={this.cancel}>CANCEL</button>

            </div >
        </div >
    { this.state.Okmessage && <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} /> }

      </div >
    );
}
});

let mapStateToProps = (state) => {
    return {
        UserDetails:state.User,
        FacilitiesDetails: state.Facilites,
        LogingDetails: state.User.loginData
    };
};

let mapDispatchToProps = (dispatch) => ({
    FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Editfacility));



/** WEBPACK FOOTER **
 ** ./src/components/facilitiesScreen/edit-facility.js
 **/